class SizeIndicator extends HTMLElement {
  constructor() {
    super();
    if (!this.dataset.selectedSize) {
      this.style.display = 'none';
      return;
    }
  }
}

if (!customElements.get('size-indicator')) {
  customElements.define('size-indicator', SizeIndicator);
}
